var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.game)?_c('div',{staticClass:"text-danger"},[_c('img',{attrs:{"src":_vm.game.thumbnail}}),_vm._v(" "),_c('br'),_vm._v("\n    "+_vm._s(_vm.game.name)+" by "+_vm._s(_vm.game.vendor)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa0cec08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/casino/gameCard.vue
// module id = c61I
// module chunks = 1